import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { BUTTON_TEXT_CANCEL, LABEL_DECLINE_OF_TRUSTED_CONTACT, BUTTON_TEXT_DECLINE } from '../../../shared/lib/constants';
import { ContactOptOutConfirmationProps } from '../app/interfaceTypes';

const ContactOptOutConfirmation: FC<ContactOptOutConfirmationProps> = ({ open, onClose, onSubmit, username }) => {
  return (
    <Dialog open={open}>
      <DialogTitle>{LABEL_DECLINE_OF_TRUSTED_CONTACT}</DialogTitle>
      <DialogContent>
        If you choose to decline as a trusted contact for <strong> {username}</strong> now, you won’t be able to be added to their VIP Rolodex later.
      </DialogContent>
      <DialogActions>
        <Button onClick={onSubmit}>{BUTTON_TEXT_DECLINE}</Button>
        <Button onClick={onClose}>{BUTTON_TEXT_CANCEL}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactOptOutConfirmation;
